import i18n from '@app/dashboard/tools/i18n';
import type { TCountry, TLabelValuePair } from '@app/dashboard/types/outerLayout/common';
import { getCountryFromDomain } from '@app/dashboard/utils/getCountryFromDomain';

const { t } = i18n;

type TProvinceData = { province: string, cities: TLabelValuePair[] };

export const country: TCountry = getCountryFromDomain();

export const products: { label: string, apiKey: string }[] = t('outerLayout.form.register.products', { returnObjects: true });

export const pakistanProvinces: TLabelValuePair[] = [
  { label: 'Azad Kashmir', value: 'Azad Kashmir' },
  { label: 'Balochistan', value: 'Balochistan' },
  { label: 'Gilgit Baltistan', value: 'Gilgit Baltistan' },
  { label: 'Islamabad', value: 'Islamabad' },
  { label: 'Khyber Pakhtunkhwa', value: 'Khyber Pakhtunkhwa' },
  { label: 'Punjab', value: 'Punjab' },
  { label: 'Sindh', value: 'Sindh' },
];

export const pakistanProvinceBasedCities: TProvinceData[] = [
  {
    province: "Azad Kashmir",
    cities: [
      {
        label: "Athmuqam",
        value: "Athmuqam"
      },
      {
        label: "Bagh",
        value: "Bagh"
      },
      {
        label: "Kotli",
        value: "Kotli"
      },
      {
        label: "Muzaffarabad",
        value: "Muzaffarabad"
      },
      {
        label: "New Mirpur",
        value: "New Mirpur"
      },
      {
        label: "Rawala Kot",
        value: "Rawala Kot"
      },
    ]
  },
  {
    province: "Balochistan",
    cities: [
      {
        label: "Awaran",
        value: "Awaran"
      },
      {
        label: "Barkhan",
        value: "Barkhan"
      },
      {
        label: "Chaman",
        value: "Chaman"
      },
      {
        label: "Dalbandin",
        value: "Dalbandin"
      },
      {
        label: "Dera Allahyar",
        value: "Dera Allahyar"
      },
      {
        label: "Dera Bugti",
        value: "Dera Bugti"
      },
      {
        label: "Dera Murad Jamali",
        value: "Dera Murad Jamali"
      },
      {
        label: "Gandava",
        value: "Gandava"
      },
      {
        label: "Gwadar",
        value: "Gwadar"
      },
      {
        label: "Kalat",
        value: "Kalat"
      },
      {
        label: "Kharan",
        value: "Kharan"
      },
      {
        label: "Khuzdar",
        value: "Khuzdar"
      },
      {
        label: "Kohlu",
        value: "Kohlu"
      },
      {
        label: "Loralai",
        value: "Loralai"
      },
      {
        label: "Mastung",
        value: "Mastung"
      },
      {
        label: "Musa Khel Bazar",
        value: "Musa Khel Bazar"
      },
      {
        label: "Panjgur",
        value: "Panjgur"
      },
      {
        label: "Pishin",
        value: "Pishin"
      },
      {
        label: "Qila Saifullah",
        value: "Qila Saifullah"
      },
      {
        label: "Quetta",
        value: "Quetta"
      },
      {
        label: "Sibi",
        value: "Sibi"
      },
      {
        label: "Turbat",
        value: "Turbat"
      },
      {
        label: "Uthal",
        value: "Uthal"
      },
      {
        label: "Zhob",
        value: "Zhob"
      },
      {
        label: "Ziarat",
        value: "Ziarat"
      },
    ]
  },
  {
    province: "Gilgit Baltistan",
    cities: [
      {
        label: "Aliabad",
        value: "Aliabad"
      },
      {
        label: "Chilas",
        value: "Chilas"
      },
      {
        label: "Dainyor",
        value: "Dainyor"
      },
      {
        label: "Eidgah",
        value: "Eidgah"
      },
      {
        label: "Gakuch",
        value: "Gakuch"
      },
      {
        label: "Gilgit",
        value: "Gilgit"
      },
    ]
  },
  {
    province: "Islamabad",
    cities: [
      {
        label: "Islamabad",
        value: "Islamabad"
      },
    ]
  },
  {
    province: "Khyber Pakhtunkhwa",
    cities: [
      {
        label: "Abbottabad",
        value: "Abbottabad"
      },
      {
        label: "Alpurai",
        value: "Alpurai"
      },
      {
        label: "Bannu",
        value: "Bannu"
      },
      {
        label: "Batgram",
        value: "Batgram"
      },
      {
        label: "Charsadda",
        value: "Charsadda"
      },
      {
        label: "Chitral",
        value: "Chitral"
      },
      {
        label: "Daggar",
        value: "Daggar"
      },
      {
        label: "Dasu",
        value: "Dasu"
      },
      {
        label: "Dera Ismail Khan",
        value: "Dera Ismail Khan"
      },
      {
        label: "Hangu",
        value: "Hangu"
      },
      {
        label: "Haripur",
        value: "Haripur"
      },
      {
        label: "Karak",
        value: "Karak"
      },
      {
        label: "Kohat",
        value: "Kohat"
      },
      {
        label: "Kulachi",
        value: "Kulachi"
      },
      {
        label: "Lakki",
        value: "Lakki"
      },
      {
        label: "Malakand",
        value: "Malakand"
      },
      {
        label: "Mansehra",
        value: "Mansehra"
      },
      {
        label: "Mardan",
        value: "Mardan"
      },
      {
        label: "Mingaora",
        value: "Mingaora"
      },
      {
        label: "Nowshera",
        value: "Nowshera"
      },
      {
        label: "Parachinar",
        value: "Parachinar"
      },
      {
        label: "Peshawar",
        value: "Peshawar"
      },
      {
        label: "Risalpur Cantonment",
        value: "Risalpur Cantonment"
      },
      {
        label: "Saidu Sharif",
        value: "Saidu Sharif"
      },
      {
        label: "Swabi",
        value: "Swabi"
      },
      {
        label: "Tank",
        value: "Tank"
      },
      {
        label: "Timargara",
        value: "Timargara"
      },
      {
        label: "Upper Dir",
        value: "Upper Dir"
      },
    ]
  },
  {
    province: "Punjab",
    cities: [
      {
        label: "Abdul Hakim",
        value: "Abdul Hakim"
      },
      {
        label: "Ahmadpur East",
        value: "Ahmadpur East"
      },
      {
        label: "Attock City",
        value: "Attock City"
      },
      {
        label: "Attock Khurd",
        value: "Attock Khurd"
      },
      {
        label: "Bahawalnagar",
        value: "Bahawalnagar"
      },
      {
        label: "Bahawalpur",
        value: "Bahawalpur"
      },
      {
        label: "Bhakkar",
        value: "Bhakkar"
      },
      {
        label: "Bhalwal",
        value: "Bhalwal"
      },
      {
        label: "Chakwal",
        value: "Chakwal"
      },
      {
        label: "Chenab Nagar",
        value: "Chenab Nagar"
      },
      {
        label: "Chiniot",
        value: "Chiniot"
      },
      {
        label: "Chishtian",
        value: "Chishtian"
      },
      {
        label: "Chunian",
        value: "Chunian"
      },
      {
        label: "Dera Ghazi Khan",
        value: "Dera Ghazi Khan"
      },
      {
        label: "Dipalpur",
        value: "Dipalpur"
      },
      {
        label: "Faisalabad",
        value: "Faisalabad"
      },
      {
        label: "Gojra",
        value: "Gojra"
      },
      {
        label: "Gujranwala",
        value: "Gujranwala"
      },
      {
        label: "Gujrat",
        value: "Gujrat"
      },
      {
        label: "Hafizabad",
        value: "Hafizabad"
      },
      {
        label: "Harunabad",
        value: "Harunabad"
      },
      {
        label: "Hasilpur",
        value: "Hasilpur"
      },
      {
        label: "Hassan Abdal",
        value: "Hassan Abdal"
      },
      {
        label: "Hujra Shah Muqim",
        value: "Hujra Shah Muqim"
      },
      {
        label: "Jalalpur Jattan",
        value: "Jalalpur Jattan"
      },
      {
        label: "Jaranwala",
        value: "Jaranwala"
      },
      {
        label: "Jhang City",
        value: "Jhang City"
      },
      {
        label: "Jhelum",
        value: "Jhelum"
      },
      {
        label: "Kabirwala",
        value: "Kabirwala"
      },
      {
        label: "Kahror Pakka",
        value: "Kahror Pakka"
      },
      {
        label: "Kamalia",
        value: "Kamalia"
      },
      {
        label: "Kasur",
        value: "Kasur"
      },
      {
        label: "Khanewal",
        value: "Khanewal"
      },
      {
        label: "Khanpur",
        value: "Khanpur"
      },
      {
        label: "Kharian",
        value: "Kharian"
      },
      {
        label: "Khushab",
        value: "Khushab"
      },
      {
        label: "Kot Addu",
        value: "Kot Addu"
      },
      {
        label: "Kundian",
        value: "Kundian"
      },
      {
        label: "Lahore",
        value: "Lahore"
      },
      {
        label: "Lala Musa",
        value: "Lala Musa"
      },
      {
        label: "Leiah",
        value: "Leiah"
      },
      {
        label: "Lodhran",
        value: "Lodhran"
      },
      {
        label: "Mandi Bahauddin",
        value: "Mandi Bahauddin"
      },
      {
        label: "Mandi Burewala",
        value: "Mandi Burewala"
      },
      {
        label: "Mian Channun",
        value: "Mian Channun"
      },
      {
        label: "Mianwali",
        value: "Mianwali"
      },
      {
        label: "Multan",
        value: "Multan"
      },
      {
        label: "Muridke",
        value: "Muridke"
      },
      {
        label: "Muzaffargarh",
        value: "Muzaffargarh"
      },
      {
        label: "Nankana Sahib",
        value: "Nankana Sahib"
      },
      {
        label: "Narowal",
        value: "Narowal"
      },
      {
        label: "Okara",
        value: "Okara"
      },
      {
        label: "Pakpattan",
        value: "Pakpattan"
      },
      {
        label: "Pasrur",
        value: "Pasrur"
      },
      {
        label: "Pattoki",
        value: "Pattoki"
      },
      {
        label: "Rahimyar Khan",
        value: "Rahimyar Khan"
      },
      {
        label: "Rajanpur",
        value: "Rajanpur"
      },
      {
        label: "Rawalpindi",
        value: "Rawalpindi"
      },
      {
        label: "Saddiqabad",
        value: "Saddiqabad"
      },
      {
        label: "Sahiwal",
        value: "Sahiwal"
      },
      {
        label: "Sambrial",
        value: "Sambrial"
      },
      {
        label: "Samundri",
        value: "Samundri"
      },
      {
        label: "Sargodha",
        value: "Sargodha"
      },
      {
        label: "Shakargarh",
        value: "Shakargarh"
      },
      {
        label: "Shekhupura",
        value: "Shekhupura"
      },
      {
        label: "Shujaabad",
        value: "Shujaabad"
      },
      {
        label: "Sialkot",
        value: "Sialkot"
      },
      {
        label: "Toba Tek Singh",
        value: "Toba Tek Singh"
      },
      {
        label: "Vihari",
        value: "Vihari"
      },
    ]
  },
  {
    province: "Sindh",
    cities: [
      {
        label: "Badin",
        value: "Badin"
      },
      {
        label: "Dadu",
        value: "Dadu"
      },
      {
        label: "Ghotki",
        value: "Ghotki"
      },
      {
        label: "Hyderabad City",
        value: "Hyderabad City"
      },
      {
        label: "Jacobabad",
        value: "Jacobabad"
      },
      {
        label: "Jamshoro",
        value: "Jamshoro"
      },
      {
        label: "Kandhkot",
        value: "Kandhkot"
      },
      {
        label: "Karachi",
        value: "Karachi"
      },
      {
        label: "Khairpur Mir’s",
        value: "Khairpur Mir’s"
      },
      {
        label: "Larkana",
        value: "Larkana"
      },
      {
        label: "Matiari",
        value: "Matiari"
      },
      {
        label: "Mirpur Khas",
        value: "Mirpur Khas"
      },
      {
        label: "Naushahro Firoz",
        value: "Naushahro Firoz"
      },
      {
        label: "Nawabshah",
        value: "Nawabshah"
      },
      {
        label: "Sanghar",
        value: "Sanghar"
      },
      {
        label: "Shahdad Kot",
        value: "Shahdad Kot"
      },
      {
        label: "Shikarpur",
        value: "Shikarpur"
      },
      {
        label: "Sukkur",
        value: "Sukkur"
      },
      {
        label: "Tando Allahyar",
        value: "Tando Allahyar"
      },
      {
        label: "Tando Muhammad Khan",
        value: "Tando Muhammad Khan"
      },
      {
        label: "Thatta",
        value: "Thatta"
      },
      {
        label: "Umarkot",
        value: "Umarkot"
      },
    ]
  }
];

export const mccs: TLabelValuePair[] = [
  {
    label: "Accessories",
    value: "Accessories"
  },
  {
    label: "Accounting Services",
    value: "Accounting Services"
  },
  {
    label: "Auto parking lots and Garages",
    value: "Auto parking lots and Garages"
  },
  {
    label: "Bakeries",
    value: "Bakeries"
  },
  {
    label: "Caterer",
    value: "Caterer"
  },
  {
    label: "Charity",
    value: "Charity"
  },
  {
    label: "Cleaning / Laundry",
    value: "Cleaning / Laundry"
  },
  {
    label: "Clothing Stores",
    value: "Clothing Stores"
  },
  {
    label: "Cosmetics",
    value: "Cosmetics"
  },
  {
    label: "Delivery Services & Freight",
    value: "Delivery Services & Freight"
  },
  {
    label: "Doctors",
    value: "Doctors"
  },
  {
    label: "Drivers",
    value: "Drivers"
  },
  {
    label: "Educational Services",
    value: "Educational Services"
  },
  {
    label: "Electronics & Gadgets",
    value: "Electronics & Gadgets"
  },
  {
    label: "Florists",
    value: "Florists"
  },
  {
    label: "Food Stores/Food Trucks",
    value: "Food Stores/Food Trucks"
  },
  {
    label: "Freelancers",
    value: "Freelancers"
  },
  {
    label: "Fuel",
    value: "Fuel"
  },
  {
    label: "Gift Shops",
    value: "Gift Shops"
  },
  {
    label: "Groceries & Supermarket",
    value: "Groceries & Supermarket"
  },
  {
    label: "Health Salons",
    value: "Health Salons"
  },
  {
    label: "Insurance",
    value: "Insurance"
  },
  {
    label: "Jewelry Stores",
    value: "Jewelry Stores"
  },
  {
    label: "Motion Picture Theater",
    value: "Motion Picture Theater"
  },
  {
    label: "Optical Goods",
    value: "Optical Goods"
  },
  {
    label: "Pet Shops",
    value: "Pet Shops"
  },
  {
    label: "Pharmacies & Medical Supplies",
    value: "Pharmacies & Medical Supplies"
  },
  {
    label: "Real Estate Brokers",
    value: "Real Estate Brokers"
  },
  {
    label: "Sports & Clubs",
    value: "Sports & Clubs"
  },
  {
    label: "Stationaries",
    value: "Stationaries"
  },
  {
    label: "Telecommunication",
    value: "Telecommunication"
  },
  {
    label: "Transportation",
    value: "Transportation"
  },
  {
    label: "Travel Agencies",
    value: "Travel Agencies"
  },
  {
    label: "Utilities",
    value: "Utilities"
  },
  {
    label: "Other",
    value: "Other"
  },
];

export const preferredLanguages: TLabelValuePair[] = t('outerLayout.form.register.preferredLanguages', { returnObjects: true });

export const getRelatedLabel = (value: string, labelValueArr: TLabelValuePair[]) => {
  const relatedLabel = labelValueArr.find(lang => lang.value === value)?.label;
  return relatedLabel;
};